import {
  type ClientCategoriesState,
  emptyClientCategories,
} from '../../_shared/domain/licence-client-categories';
import { type CsmCandidatesState, emptyCsmCandidates } from '../../_shared/domain/licence-csm';
import type { AddLicenceError, LicenceDraft, SaveStatus } from '../domain/licence-draft.model';

/**
 * Live name-availability verdict; a 4-value lifecycle (not a boolean) because
 * the UI must tell "not yet checked" apart from "checked and free".
 */
export type NameAvailability = 'idle' | 'checking' | 'taken' | 'available';

/**
 * Redux state for the Add Licence form. A three-field create form, so the shape
 * is small: the editable draft, per-field validation errors, the save lifecycle,
 * the last business error, the live name-availability verdict, and the id of the
 * licence just created (drives the success navigation), and the people the
 * Customer Success Manager select offers (#583), and the client category list
 * with its "Add a category" request (#604). Every field is serialisable.
 */
export interface AddLicenceState {
  draft: LicenceDraft;
  validationErrors: Record<string, string>;
  saveStatus: SaveStatus;
  error: AddLicenceError | null;
  nameAvailability: NameAvailability;
  createdLicenceId: string | null;
  csmCandidates: CsmCandidatesState;
  clientCategories: ClientCategoriesState;
}

export const emptyDraft: LicenceDraft = {
  name: '',
  client_category: '',
  based_in: '',
  csm_user_id: '',
};

export const initialState: AddLicenceState = {
  draft: emptyDraft,
  validationErrors: {},
  saveStatus: 'idle',
  error: null,
  nameAvailability: 'idle',
  createdLicenceId: null,
  csmCandidates: emptyCsmCandidates,
  clientCategories: emptyClientCategories,
};
